import styled from 'styled-components';
import { ReactComponent as RawUserlistSVG } from '../../../../assets/icons/icon_userlist.svg';

export const IconUserlist = styled(RawUserlistSVG)``;
